import React, { Component } from 'react';
import Form from './component/form';
import Result from './component/result';

const createNewEvent = (eventName) => {
  var event;
  if (typeof(Event) === 'function') {
      event = new Event(eventName);
  } else {
      event = document.createEvent('Event');
      event.initEvent(eventName, true, true);
  }
  return event;
}
const _s = {
  main: document.getElementsByTagName("main")[0],
  sidebar: document.querySelector('.t-sidebar'),
  unlockSection: document.getElementById('unlock'),
  init: function(yPos){
    let left =_s.getOffset(_s.sidebar).x,
        stopPos = yPos - _s.sidebar.offsetHeight;
    window.addEventListener('resize', () => {
          left =_s.getOffset(_s.sidebar).x
    })
    window.addEventListener('scroll', function() {
      let scrollTarget = _s.main.offsetTop
      if (this.scrollY > scrollTarget && this.scrollY < stopPos){
        _s.sidebar.classList.add('sticky')
        _s.sidebar.classList.remove('sticky-bottom')
        _s.sidebar.setAttribute('style', 'left: '+ left + 'px')
      }else if (this.scrollY >= stopPos){
        _s.sidebar.classList.remove('sticky')
        _s.sidebar.classList.add('sticky-bottom')
        _s.sidebar.removeAttribute('style')
      }else{
        _s.sidebar.removeAttribute('style')
        _s.sidebar.classList.remove('sticky')
        _s.sidebar.classList.remove('sticky-bottom')
      }
    })
  },
  getOffset: function(element){
    const { top, left } = element.getBoundingClientRect();
    let point;
    point = {
      x: left + window.pageXOffset,
      y: top + window.pageYOffset
    };
    return point
  }
}

class App extends Component {
  constructor(props){
    super(props)
    this.state = {
      index: 1,
      showResult: false, 
      busy: false,
      email: '',
      sidebar: [
        "Involve key sponsors early and often",
        "Don't produce innovation, enable it",
        "Reach unexpected innovators by making innovation mobile and real-time",
        "Motivate your employees and other innovators by inspiring them",
        "Aim beyond one-and-done",
        "Pick the right software and partner"
      ]
    }
  }
  componentDidMount() {
    window.MktoForms2.loadForm("//app-ab22.marketo.com", "456-QCH-520", 2306, function(form){

      var script = document.createElement("script");
      var head = document.head || document.getElementsByTagName("head")[0];
      script.type = "text/javascript";
      script.src = "//sfc.leadspace.com/SmartForms.js"; 
      script.dataset.token = "351";
      head.appendChild(script);
      // SF4 capture event as parameter
      window.companyUpdate = createNewEvent('update')
      document.getElementById("Company").addEventListener("update", function(e){
        // window.sf$.fieldChanged(e)
        window.sf$.sf5.handlers.fieldChangedHandler(e)
			});

      window.myForm = form
    })
    // this.toggleResult()
    // _s.init( document.querySelector('.resources').offsetTop )
    _s.init( document.getElementById('unlock').offsetTop )
  }
  setFormEmail(email){
    // console.log(email)
    this.setState({email})
  }
  toggleResult(){
    this.setState({showResult: true})
    var x = document.getElementsByTagName("BODY")[0]
    if (this.state.showResult){
        let  y = document.getElementById('unlockBtn'),
          z = document.getElementById('tips');
          let html = ""
      this.state.sidebar.forEach((item, i) => {
        html += `<li>
        <span class="lead">Tip #${i+1}</span>
        <a href="#tip${i+1}">${item}</a>
        </li>`
      })
      z.innerHTML = html
      y.remove()
    }
    x.classList.add(this.state.showResult? 'result-mode' : 'form-mode')
    _s.init( document.querySelector('.resources').offsetTop )
  }
  
  render() {
    return (
      <>
      {
        this.state.showResult && <Result email={this.state.email} />
      }
      {
        !this.state.showResult &&
        <>
          <section className="blue-quote">
            <div className="container">
              <span className="icon-quote"></span>
              <p>“Digital business executives and software development leaders should not settle for separate digital labs; instead, create a seamless organization that is empowered to work differently, with innovation as part of its DNA.”</p>
              <hr className="stubby" />
              <p className="function">via Forrester report The Downside Of Digital Labs</p>
            </div>
          </section>
          <section className="main">
            <div className="container">
              <aside>
                <h2 className="l2-heading">Want more?</h2>
                <p>Unlock the rest of the tips for free.</p>
              </aside>
              <Form showResult={this.toggleResult.bind(this)} setEmail={this.setFormEmail.bind(this)}/>
            </div>
          </section>
        </>
      }
      </>
    );
  }
}

export default App;
